import { getAllProjectWrappers } from 'API/project-wrapper';
import { useUserData } from 'hooks/use-user-data';
import { useEffect, useState } from 'react';
import useErrorStore from 'stores/error-store';
import { OptionType } from '../../ui/base-components/pai-auto-complete';

export const useProjectWrappers = (wrapperType?: 'normal' | 'li_search') => {
  useUserData();
  const handleOpenErrorDialog = useErrorStore((state) => state.handleOpenErrorDialog);

  const [projectWrappers, setProjectWrappers] = useState<OptionType[]>([]);

  useEffect(() => {
    (async () => {
      const res = await getAllProjectWrappers(wrapperType);

      if (res && !res.error) {
        const tempWrappers = res.projectWrappers;

        const mappedWrappers: OptionType[] = tempWrappers?.map((wrapper: any) => ({ label: wrapper.name, value: wrapper._id }));

        setProjectWrappers(mappedWrappers);
      } else {
        setProjectWrappers([]);
        handleOpenErrorDialog(res?.error, '/projects/wrappers', 'get');
      }
    })();
  }, []);

  return projectWrappers;
};

export default useProjectWrappers;
